import MsiUpload from "./src/MsiUpload.vue";

export default MsiUpload;
